module.exports = __webpack_public_path__ + "static/media/icon-category.74cef1c8.svg";